/* SNS WORLD V2 — assets/sns-motion.js
   reveal-on-scroll + hero "il mondo segue lo scroll" (video gioca + zoom GPU).
   Niente seek di currentTime → fluido. Tutto gated su prefers-reduced-motion. */
(function () {
  function init() {
    var motionOK = window.matchMedia('(prefers-reduced-motion: no-preference)').matches;

    /* reveal on scroll */
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            var d = parseInt(e.target.getAttribute('data-delay') || '0', 10);
            setTimeout(function () { e.target.classList.add('in'); }, motionOK ? d : 0);
            io.unobserve(e.target);
          }
        });
      }, { threshold: 0.18 });
      document.querySelectorAll('[data-reveal]').forEach(function (el) { io.observe(el); });
    } else {
      document.querySelectorAll('[data-reveal]').forEach(function (el) { el.classList.add('in'); });
    }

    /* hero SCROLL-SCRUB: il video scorre AVANTI scendendo, INDIETRO salendo.
       Niente loop/autoplay: currentTime è guidato dallo scroll (lerp = fluido).
       Richiede MP4 all-intra (ogni frame keyframe) per seek liscio. */
    var vid = document.getElementById('sns-skyvid');
    var wrap = document.querySelector('.sns-cielo-wrap');
    var isTouch = window.matchMedia('(hover: none), (pointer: coarse)').matches || window.innerWidth <= 900;
    if (motionOK && vid && wrap && isTouch) {
      /* MOBILE/touch: niente scrub. Autoplay loop → iOS dipinge il video
         (un video in pausa "scrubbato" su iOS resta nero, niente nuvole). */
      vid.loop = true; vid.muted = true; vid.setAttribute('playsinline', '');
      var pm = vid.play(); if (pm && pm.catch) pm.catch(function () {});
    } else if (motionOK && vid && wrap) {
      var cue = wrap.querySelector('.sns-scrollcue');
      var dur = 0, ready = false;
      var arm = function () {
        dur = vid.duration || 0;
        try { vid.pause(); vid.currentTime = 0.001; } catch (e) {}
      };
      if (vid.readyState >= 1) arm(); else vid.addEventListener('loadedmetadata', arm, { once: true });
      /* scrub SOLO quando il video è bufferizzato abbastanza: evita gli scatti
         all'ingresso (seek su video non ancora caricato) */
      var markReady = function () { ready = true; };
      if (vid.readyState >= 4) ready = true;
      else { vid.addEventListener('canplaythrough', markReady, { once: true });
             vid.addEventListener('canplay', markReady, { once: true }); }

      var target = 0, current = 0, raf = null;
      var loop = function () {
        current += (target - current) * 0.12;
        /* salta il seek se non pronto o se un seek è già in corso (anti-thrash) */
        if (ready && dur && !vid.seeking) {
          var want = current * (dur - 0.05);
          if (Math.abs(vid.currentTime - want) > 0.03) {
            try { vid.currentTime = want; } catch (e) {}
          }
        }
        vid.style.transform = 'scale(' + (1.04 + current * 0.10) + ')';
        if (cue) cue.style.opacity = String(0.7 * Math.max(0, 1 - target * 3.2));
        if (Math.abs(target - current) > 0.0008) raf = requestAnimationFrame(loop); else raf = null;
      };
      var onScroll = function () {
        var r = wrap.getBoundingClientRect();
        target = Math.min(1, Math.max(0, -r.top / (r.height - window.innerHeight)));
        if (!raf) raf = requestAnimationFrame(loop);
      };
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
    }

    /* Cap III: il pianeta SNS WORLD gira mentre scorri */
    var ring = document.querySelector('.sns-mondo .anello');
    if (motionOK && ring) {
      var rtick = false;
      var spin = function () {
        var r = ring.getBoundingClientRect();
        var p = (window.innerHeight - r.top) / (window.innerHeight + r.height);
        if (p > -0.4 && p < 1.4) {
          ring.style.transform = 'translate(-50%,-50%) rotate(' + ((p - 0.5) * 46).toFixed(2) + 'deg)';
        }
        rtick = false;
      };
      window.addEventListener('scroll', function () {
        if (rtick) return; rtick = true; requestAnimationFrame(spin);
      }, { passive: true });
      spin();
    }
  }
  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
